export const APP_SETTING = {
    section_1_id: {
        oca_indonesia: {
            name: 'OCA Indonesia',
            description: 'Komunikasi omnichannel <br> dengan lebih mudah ke <br> semua pelanggan',
            button_try: 'Coba Demo Gratis'
        },
        oca_blast: {
            name: 'OCA Blast',
            description: 'Kirim pesan ke <br> semua channel dengan mudah, <br> untuk pelanggan Anda',
            button_try: 'Coba Demo Gratis'
        },
        oca_interaction: {
            name: 'OCA Interaction',
            description: 'Aplikasi CRM untuk <br> optimalisasi pelayanan <br> & performa tim Anda.',
            button_try: 'Coba Demo Gratis'
        }
    },
    section_1_eng: {
        oca_indonesia: {
            name: 'OCA Indonesia',
            description: 'Omnichannel <br> communication for <br> seamless chat with customer',
            button_try: 'Get a Demo'
        },
        oca_blast: {
            name: 'OCA Blast',
            description: 'Blast broadcast Email, SMS, <br> IVR, and WhatsApp to <br> thousands of contacts',
            button_try: 'Get a Demo'
        },
        oca_interaction: {
            name: 'OCA Interaction',
            description: 'Communication CRM for <br> marketing, sales & <br> customer service',
            button_try: 'Get a Demo'
        }
    },
    section_2_eng: {
        title: "Trusted by",
        oca_growth: {
            name: "Your growth is our goal",
            title_1: "Message sent to customers",
            title_2: "Companies choose OCA",
            title_3: "Reached customers",
            value_1: "102.850.000+",
            value_2: "5000+",
            value_3: "2.900.000+"
        }
    },
    section_2_id: {
        title: "Mereka menggunakan OCA",
        oca_growth: {
            name: "OCA berkembang <br/> bersama Anda",
            title_1: "Pesan terkirim ke pelanggan",
            title_2: "Perusahaan memilih OCA",
            title_3: "Pelanggan Terhubung",
            value_1: "102.850.000+",
            value_2: "5000+",
            value_3: "2.900.000+"
        }
    },
    section_3_eng: {
        title: "Enhance all of your communication <br/> for a better customer experience",
        oca_blast: {
            name: "OCA Blast",
            title: "Blast your SMS, Email, IVR and WhatsApp",
            description: "Spread promotions and reach out to your customers directly from SMS, Email, IVR, and WhatsApp. Increase conversions rate with consistent marketing.",
            additional: "Read more"
        },
        oca_interaction: {
            name: "OCA Interaction",
            title: "Multiple channel in a single Customer Service CRM",
            description: "Build a relationship with your customers and save the contact to make agent's work easier with CRM Tools.",
            additional: "Read more"
        },
        oca_api: {
            name: "OCA API",
            title: "Integrate your system with OCA API",
            description: "Integrate your platform to our dashboard using API. You can also have your own official WhatsApp Business and Chatbot.",
            additional: "Read more"
        },
        oca_chatbot: {
            name: "OCA Automated Interaction",
            title: "Automate Your Chat Center Conversations",
            description: "With OCA AI, you can get a powerful chatbot platform that integrates with many channels, a chatbot performance report feature, and without code.",
            additional: "Read more"
        }
    },
    section_3_id: {
        title: "Mulai dari pesan pertama hingga <br/> meningkatkan customer experience",
        oca_blast: {
            name: "OCA Blast",
            title: "Kirim SMS, Email, IVR, hingga WhatsApp Blast",
            description: "Promosi blast atau menghubungi pelanggan langsung ke SMS, Email, IVR, hingga WhatsApp. Perbesar konversi dengan marketing yang konsisten.",
            additional: "Selengkapnya"
        },
        oca_interaction: {
            name: "OCA Interaction",
            title: "Balas semua chat customer di satu CRM",
            description: "Bangun customer relationship yang lebih kuat dengan live chat Anda di satu tempat. Simpan kontak customer untuk memudahkan admin.",
            additional: "Selengkapnya"
        },
        oca_api: {
            name: "OCA API",
            title: "Hubungkan platform lain dengan OCA API",
            description: "Tambah API dari platform yang Anda sudah miliki ke dashboard kami. Anda juga bisa memiliki WhatsApp Business dan Chatbot.",
            additional: "Selengkapnya"
        },
        oca_chatbot: {
            name: "OCA Automated Interaction",
            title: "Percakapan Otomatis untuk Semua Layanan Anda",
            description: "Dengan OCA AI, Anda bisa mendapatkan platform chatbot canggih yang terintegrasi dengan banyak saluran, diikuti dengan laporan kinerja chatbot, dan tanpa koding sekalipun.",
            additional: "Selengkapnya"
        }
    },
    section_4_id: {
        title: "Platform komunikasi omichannel <br/> dengan fitur lengkap",
        description: "Sesuaikan kebutuhan komunikasi Anda dengan fitur yang tersedia di OCA"
    },
    section_4_eng: {
        title: "Omnichannel communication platform <br/>  with all features you need",
        description: "Customize your communication needs with the features available in OCA"
    },
    section_5_id: {
        title: "Gunakan OCA untuk semua kebutuhan bisnis",
        button_blog: "Lebih lanjut",
        feedback: "Layanan OCA sesuai dengan kebutuhan kami. Dengan OCA lebih mudah memantau status email blast yang telah dikirimkan."
    },
    section_5_eng: {
        title: "Full-featured omnichannel <br/> communication platform",
        button_blog: "Read more",
        feedback: "OCA services fit our needs. It's easier to monitor email blast status that has been sent with OCA."
    },
    footer_id: {
        title: "Jalin Komunikasi Praktis dengan <br/> Pelanggan Anda",
        description: "Coba gratis sekarang dan temukan berbagai layanan omnichannel <br/> sesuai kebutuhan bisnis Anda.",
        button_try: "Register",
        button_contact: "Jadwalkan Demo"
    },
    footer_eng: {
        title: "Seamlessly Connect with Your <br/> Customers",
        description: "Start your free trial now and explore multiple omnichannel <br/> services that suit your business needs.",
        button_try: "Register",
        button_contact: "Get a Demo"
    }
};

export const APP_LAYOUT = {
    header_eng: {
        product: {
            name: 'Product',
            oca_blast: {
                title: 'OCA Blast',
                description: 'Blast text or voice messages through all channels faster & easier.'
            },
            oca_interaction: {
                title: 'OCA Interaction',
                description: 'All-in-one CRM application to connect with your customers from various channels.'
            },
            oca_profiling: {
                title: 'OCA Profiling',
                description: 'Adjust target with your customer behavior.'
            },
            oca_whatsapp: {
                title: 'OCA WhatsApp Business API',
                description: 'WhatsApp Business API official for messaging and automation.'
            },
            oca_chatbot: {
                title: 'OCA AI',
                description: 'Automate Your Chat Center Conversations.'
            }
        },
        solution: {
            name: 'Solution',
            umkm: {
                title: 'SME',
                description: 'Digital communication solution for SME to reach out to customers easier.'
            },
            startup: {
                title: 'Startup',
                description: 'Thrive up your startup by connecting with more customers.'
            },
            enterprise: {
                title: 'Enterprise',
                description: 'Keep in touch with countless customers anytime and anywhere.'
            },
        },
        pricing: {
            name: 'Pricing',
            text: 'Pricing',
        },
        partnership: {
            name: 'Partnership',
        },
        resources: {
            name: 'Resources',
            faq: {
                title: 'FAQ',
                description: 'Find out the solution and answer your question here.'
            },
            documentation: {
                title: 'OCA Product Documentation',
                description: 'The latest documentation, including user guide, release note updates, and API reference.'
            },
            blog: {
                title: 'Blog',
                description: 'Read excisting news, tips, and update on the latest OCA products.'
            },
        },
        about: {
            name: 'About Us',
        },
        button_login: 'Login',
        button_signup: 'Try for Free',
    },
    header_id: {
        product: {
            name: 'Produk',
            oca_blast: {
                title: 'OCA Blast',
                description: 'Kirim pesan blast text atau suara ke banyak channel lebih mudah & cepat.'
            },
            oca_interaction: {
                title: 'OCA Interaction',
                description: 'CRM All-in-one untuk balas chat dari berbagai channel messaging.'
            },
            oca_profiling: {
                title: 'OCA Profiling',
                description: 'Adjust target with your customer behavior.'
            },
            oca_whatsapp: {
                title: 'OCA WhatsApp Business API',
                description: 'WhatsApp Business API official untuk kirim pesan dan automasi.'
            },
            oca_chatbot: {
                title: 'OCA AI',
                description: 'Percakapan Otomatis untuk Pusat Obrolan Anda.'
            }
        },
        solution: {
            name: 'Solusi',
            umkm: {
                title: 'UMKM',
                description: 'Solusi komunikasi digital untuk UMKM agar mudah menjangkau customer.'
            },
            startup: {
                title: 'Startup',
                description: 'Kembangkan startup Anda dengan terhubung ke lebih banyak customer.'
            },
            enterprise: {
                title: 'Enterprise',
                description: 'Terhubung dengan banyak customer kapan saja dimana saja.'
            },
        },
        pricing: {
            name: 'Harga',
            text: 'Harga',
        },
        partnership: {
            name: 'Partnership',
        },
        resources: {
            name: 'Referensi',
            faq: {
                title: 'FAQ',
                description: 'Cari solusi dan jawaban dari pertanyaan Anda disini.'
            },
            documentation: {
                title: 'OCA Product Documentation',
                description: 'Dokumentasi produk paling baru, termasuk panduan pengguna, rilis update, dan referensi API'
            },
            blog: {
                title: 'Blog',
                description: 'Baca berita seru, tips dan update terbaru produk OCA'
            },
        },
        about: {
            name: 'Tentang Kami',
        },
        button_login: 'Masuk',
        button_signup: 'Mulai Sekarang',
        copyright: '© 2024 OCA Indonesia, Inc. Hak cipta dilindungi oleh Undang-Undang. Berbagai merek dagang lain adalah milik pemilik yang bersangkutan.',
    }
}